// Unique code to get top level Page Component and Page SCSS
// The only thing different is the from part should match your component
import ReactDOM from 'react-dom/client';
import React from 'react';
import PAGE_COMPONENT from './CompanyClaimPage';
import { Provider as PAGE_CONTEXT } from '../../../../contexts/PageContext';

// All boilerplate cut/paste stuff

const checkPageProps = () => {
    let props = {};
    // eslint-disable-next-line no-undef
    if (typeof globalPageProps !== 'undefined') props = globalPageProps;
    if (props.PAGE_PROPS) {
        ReactDOM.hydrateRoot(
            document.getElementById('root'),
            <PAGE_CONTEXT PAGE_PROPS={props.PAGE_PROPS}>
                <PAGE_COMPONENT {...props} />
            </PAGE_CONTEXT>
        );
    } else {
        setTimeout(() => {
            checkPageProps();
        }, 20);
    }
};
checkPageProps();

// TO USE THIS COMPONENT IN THE BACKEND:

/**
 *  To render the component:
 *
 *  req.reactRender = {
 *      componentPath: 'Employer/Marketing/CompanyClaimPage/CompanyClaimPage,
 *      props: {},
 *      metaTagData:{}
 *  }
 *
 *  next();
 *  return;
 * */
